import PropTypes from 'prop-types'
import { Item } from './Item'

export const List = ({ list, isChildren }) => {
  return (
    <ul>
      {list.map(
        (
          { route, label, children, isI18n, isLock, keepQueryStrParams },
          index,
        ) => {
          return (
            <Item
              key={index}
              route={route}
              keepQueryStrParams={keepQueryStrParams}
              label={label}
              children={children}
              isI18n={isI18n}
              isLock={isLock}
              isChildren={isChildren}
              isTopItem={index === 0}
            />
          )
        },
      )}
    </ul>
  )
}

List.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isI18n: PropTypes.bool,
      route: PropTypes.string,
      keepQueryStrParams: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  isChildren: PropTypes.bool,
}

List.defaultProps = {
  isChildren: false,
}
